import ContactCard from '@acctglobal/contact-card'
import React from 'react'

import SocialMediaCard from './SocialMediaCard'
import FacebookIcon from '../../../assets/FacebookIcon.svg'
import faqSupport from '../../../assets/faqSupport.svg'
import InstagramIcon from '../../../assets/InstagramIcon.svg'
import TiktokIcon from '../../../assets/TiktokIcon.svg'
import LinkedinIcon from '../../../assets/LinkedinIcon.svg'
import { useStoreContext } from '../../../contexts/StoreContext'
import { useTabloidsData } from '../../../hooks/useTabloids'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import Newsletter from '../../sections/Newsletter'
import './pre-footer.scss'

const PreFooter = () => {
  const { socialMediaLinks } = useStoreContext()
  const isViewFooterClub = location.pathname.includes('/club')
  const { tabloidData, error } = useTabloidsData('')
  const { isMobile } = useWindowDimensions()

  const isViewFooter = !(
    location.pathname.includes('/tabloides') &&
    (error === 'Invalid or expired date' ||
      tabloidData?.tabloidNames.length === 0 ||
      tabloidData === undefined)
  )

  const isMultipleSearchPage = location?.pathname?.includes('/busca-multipla')

  if (!isViewFooter && isMultipleSearchPage && isMobile) {
    return null
  }

  return (
    <div
      className={`container-pre-footer grid-content ${
        isViewFooterClub ? 'container-pre-footer-club' : ''
      }`}
    >
      <div className="contact">
        <a className="contact-atendimento" href="/atendimento">
          <ContactCard
            title="Dúvidas frequentes"
            subtitle="Encontre ajuda para suas dúvidas"
            image={faqSupport}
            backgroundColor="var(--color-main)"
            imgWidth={40}
            marginRightLogo={20}
          />
        </a>
      </div>

      <div className="social">
        <SocialMediaCard
          texts={['Siga-nos nas nossas redes sociais:']}
          images={[
            {
              src: FacebookIcon,
              alt: 'Facebook',
              link: socialMediaLinks?.linkFacebook,
            },
            {
              src: InstagramIcon,
              alt: 'Instagram',
              link: socialMediaLinks?.linkInstagram,
            },
            {
              src: LinkedinIcon,
              alt: 'LinkedIn',
              link: socialMediaLinks?.linkLinkedin,
            },
            {
              src: TiktokIcon,
              alt: 'Tiktok',
              link: socialMediaLinks?.linkTiktok,
            },
          ]}
        />
      </div>

      {!isViewFooterClub && (
        <div className="newsletter-container">
          <Newsletter title="Cadastre-se e receba nossas ofertas" />
        </div>
      )}
    </div>
  )
}

export default PreFooter
